import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-controller" }
const _hoisted_2 = { class: "select" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Day", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: "2" }, "Week", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: "3" }, "Month", -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "month-selection" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-left",
  title: "Previous month"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", {
  class: "fal fa-angle-right",
  title: "Next month"
}, null, -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "month-label ml-3" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("select", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.calendarView) = $event)),
        class: "month-dropdown"
      }, _hoisted_6, 512), [
        [_vModelSelect, _ctx.calendarView]
      ])
    ]),
    _createElementVNode("button", {
      class: "btn btn-default ml-2 today-btn",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.today()))
    }, " Today "),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "btn-no-border",
        onClick: _cache[2] || (_cache[2] = $event => (_ctx.prev()))
      }, _hoisted_9),
      _createElementVNode("button", {
        class: "btn-no-border",
        onClick: _cache[3] || (_cache[3] = $event => (_ctx.next()))
      }, _hoisted_11),
      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.currentDateDisplay), 1)
    ])
  ]))
}